import { DispatcherWithDispatcherCompanyUser } from "api/entities/dispatcher";
import DispatcherEditFormData from "./dispatcher-edit-form-data";
import { FormValidationDefinition } from "commons/form/useForm";
import formValidationService from "commons/form/form-validation.service";
import dispatcherEditFormValidationService from "./dispatcher-edit-form-validation.service";

const createFormData = (responseData: DispatcherWithDispatcherCompanyUser): DispatcherEditFormData => {
  return {
    companyId: responseData.user.company_id,
    companyName: responseData.user.company.company_name,
    email: responseData.user.email,
    login: responseData.user.login,
    originalLogin: responseData.user.login,
    loginCheck: {
      available: true,
      login: responseData.user.login,
    },
    name: responseData.user.name,
    phone: `${responseData.user.phone_prefix}${responseData.user.phone}`,
    surname: responseData.user.surname,
    password: "",
    passwordConfirm: "",
  };
};

const getEmptyFormData = (): DispatcherEditFormData => {
  return {
    companyId: "",
    companyName: "",
    email: "",
    login: "",
    originalLogin: "",
    loginCheck: {
      available: true,
      login: "",
    },
    name: "",
    password: "",
    passwordConfirm: "",
    phone: "",
    surname: "",
  };
};

const getFormValidationDefinition = (): FormValidationDefinition<DispatcherEditFormData> => {
  return {
    companyId: formValidationService.ok,
    companyName: formValidationService.ok,
    email: (values) => dispatcherEditFormValidationService.validateEmail(values.email),
    login: (values) =>
      dispatcherEditFormValidationService.validateLogin(values.login, values.originalLogin, values.loginCheck),
    originalLogin: formValidationService.ok,
    loginCheck: formValidationService.ok,
    name: (values) => dispatcherEditFormValidationService.validateName(values.name),
    password: (values) => formValidationService.validatePassword(values.password),
    passwordConfirm: (values) => formValidationService.validatePasswordConfirm(values.password, values.passwordConfirm),
    phone: (values) => dispatcherEditFormValidationService.validatePhone(values.phone),
    surname: (values) => dispatcherEditFormValidationService.validateSurname(values.surname),
  };
};

const dispatcherEditFormFactory = {
  createFormData,
  getEmptyFormData,
  getFormValidationDefinition,
};

export default dispatcherEditFormFactory;
